import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { MdNotStarted } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { toast } from 'react-toastify';
import { GoFileSubmodule } from "react-icons/go";
import { PiFilesFill } from "react-icons/pi";
import Cookies from 'js-cookie';
import { RiImportFill } from "react-icons/ri";
import Menu_Items from '../Menu_Items';
import { MdAddToPhotos } from "react-icons/md";

let updateval = {};

function In_Bound_Details() {
    const { id, int_id } = useParams();

    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [spl, setspl] = useState(false)
    const [user, setuser] = useState(false)
    const [In_Bound_Details, setIn_Bound_Details] = useState([]);
    const [statusval, setstatusval] = useState(false);
    const [data, setdata] = useState(false);
    const [delete_box, setdelete_box] = useState(false);
    const [delete_id, setdelete_id] = useState(null)
    const [sortOrder, setSortOrder] = useState("asc"); // Track sorting order

    const menus = [
        {
            name: 'Integrations',
            id
        },
        {
            name: 'In Bound',
            id,
            submenu: [
                { name: 'Schedule', id, int_id, type: 'In' },
                { name: 'API', id, int_id },
                { name: 'Manual', id, int_id }
            ]
        },
        (su_admin || admin ? { name: 'Users', id } : { name: null, id })
    ];
    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }
        else if (level === 'Integ Special') {
            setspl(true)
        }
        else if (level === 'Integ User') {
            setuser(true)
        }
    };
    const get_In_Bound_Details = async () => {
        await axios.get(`/in_bound/${int_id}`).then((res) => {
            setIn_Bound_Details(res.data);
            // console.log(res.data);

        }).catch((err) => {
            console.log('error');

        })
    };
    // Function to handle sorting
    const handleSort = (name) => {
        const newOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle order
        const sorted = [...In_Bound_Details].sort((a, b) => {
            if (typeof a[name] === "string") {
                return newOrder === "asc"
                    ? a[name].localeCompare(b[name])
                    : b[name].localeCompare(a[name]);
            } else {
                return newOrder === "asc" ? a[name] - b[name] : b[name] - a[name]; // Numerical sorting
            }
        });
        setIn_Bound_Details(sorted);
        setSortOrder(newOrder);
    };
    const handle_status = async (id, status) => {
        if (status === 0) { // False
            updateval.Status = 1;
        }
        else { // True
            updateval.Status = 0;
        };
        await axios.patch(`/in_bound/status/${id}`, updateval).then((res) => {
            setstatusval(!statusval);
        })
            .catch((err) => {
                toast.error("Status Updated Error", {
                    autoClose: 2000, // 2 seconds
                });
            });

    };
    const handle_delete = async () => {
        await axios.delete(`/in_bound/${delete_id}`).then((res) => {
            setdata(!data);
            setdelete_box(false)
            setdelete_id(null)
        })
            .catch((err) => {
                toast.error(`Detail Could not be Deleted`, {
                    autoClose: 2000
                });

            })
    };
    const trigger = async () => {
        await axios.get('/in_bound/check/trigger').then(res => {
            console.log(res.data);
        }).catch(err => {
            console.log(err);
        })
    }
    useEffect(() => {
        get_In_Bound_Details();
        get_level();
    }, [statusval, data]);
    return (
        <div className='container df fdc ac'>
            <Navbar />
            <div className='main_box df'>

                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <RiImportFill className='page_icon db' />
                            <p>In Bound Details</p>
                            {/* <button className='m1 btn green' onClick={trigger}>trigger</button> */}
                        </div>
                        {
                            (su_admin || admin || spl || user) && (<Link to={`/in_bound/add/${id}/${int_id}`} className='w3' ><MdAddToPhotos className='icon3 g' /></Link>)
                        }

                    </div>
                    <table className='df fdc ac box'>
                        <thead>
                            <tr className='df js ac' style={{ cursor: "pointer" }}>
                                <th onClick={() => { handleSort('import_name') }}>Name {sortOrder === "asc" ? "▲" : "▼"}</th>
                                <th onClick={() => { handleSort('from') }}>Files From {sortOrder === "asc" ? "▲" : "▼"}</th>
                                <th onClick={() => { handleSort('type') }}>Files Type {sortOrder === "asc" ? "▲" : "▼"}</th>
                                <th onClick={() => { handleSort('store') }}>Store {sortOrder === "asc" ? "▲" : "▼"}</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                In_Bound_Details.length > 0 && In_Bound_Details.map((obj, index) => {
                                    return (
                                        <tr className='df jc ac' key={index} style={{ cursor: "pointer" }}>
                                            <td className='df js ac'>{obj.import_name}</td>
                                            <td className='df js ac'>{obj.from}</td>
                                            <td className='df js ac'>{obj.type}</td>
                                            <td className='df js ac'>{obj.store}</td>
                                            <td className='df jc ac gap2'>
                                                {
                                                    (su_admin || admin || spl || user) && (<Link to={`#`} className={`df jc ac g tooltip ${obj.status === 0 ? 'g' : 'r'}`} onClick={() => { handle_status(obj.id, obj.status) }} icon-name={obj.Status === 0 ? 'Start' : 'Stop'}><MdNotStarted className='icon2' /></Link>)

                                                }
                                                {
                                                    <Link to={`/in_bound/log/${id}/${int_id}/${obj.sample}`} className='tooltip' icon-name="Log Details"><PiFilesFill className='icon2 db' /></Link>
                                                }
                                                {
                                                    <Link to={`/in_bound/${id}/${int_id}/${obj.id}`} className='tooltip' icon-name="Tables"><GoFileSubmodule className='icon2 db ' /></Link>
                                                }
                                                {
                                                    (su_admin || admin || spl || user) && (
                                                        <>
                                                            <Link to={`/in_bound/edit/${id}/${int_id}/${obj.id}`} className='tooltip' icon-name="Edit"><FaEdit className='icon2 db ' /></Link>
                                                            <Link to={`#`} className='tooltip' icon-name="Delete"><MdDeleteForever className='icon2 r' onClick={() => { setdelete_box(true); setdelete_id(obj.id) }} /></Link>
                                                        </>
                                                    )

                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }{
                                In_Bound_Details.length === 0 && <tr className='h65 df jc ac bnone'><td className='w100 bnone tac no_Records'>No Records</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                delete_box &&
                <div className='dialog_bg'>
                    <div className='delete_box'>
                        <h1 className='h5 w80 df ac r'>Delete</h1>
                        <p className='h5 w80'>Are You Sure You Want to Delete This Item ?</p>
                        <div className='h5 w40 df jb ac'>
                            <button className='btn l_black' onClick={() => setdelete_box(false)}>Cancel</button>
                            <button className='btn red' onClick={() => handle_delete()}>Delete</button>
                        </div>
                    </div>
                </div>
            }
        </div >
    )
}

export default In_Bound_Details;